import styled from 'styled-components'

export const StyledSignatureBox = styled.div`
  .canvas-wrapper {
    max-width: 420px;
    min-height: 105px;
    display: flex;
    flex-direction: column;
    background-color: #eeeeee;
    padding: 2rem 2rem 2rem 2rem;
    gap: 1rem;
  }
  .x-coord {
    position: relative;
    line-height: 4rem;

    .input-group-addon {
      transform: translateY(70px) translateX(-10px);
    }
  }
  .tool-bar {
    max-width: 420px;
    margin-bottom: 5px;
    width: inherit;
    display: flex;
    justify-content: space-between;

    .title {
      white-space: nowrap;
      font-weight: 600;
      font-size: 16px;
    }

    .clear-button {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
      }
    }
  }

  canvas {
    display: block;
    border: 1px solid;
    width: 90%;
    min-height: 105px;
    background-color: #fff;
    //border-radius: 8px 8px 0 0;
  }

  .signature-canvas {
    cursor: crosshair;
  }

  .signature-canvas.disabled {
    cursor: not-allowed;
  }

  .error-label {
    margin-top: -5px;
    margin-bottom: 5px;
  }
  .signature-content {
    display: inline-flex;
    justify-content: center;
  }
`
